import isValidDate from './isValidDate';

function getAge(date) {
    const today = new Date();
    const m = today.getMonth() - date.getMonth();

    let age = today.getFullYear() - date.getFullYear();
    if (m < 0 || (m === 0 && today.getDate() < date.getDate())) {
        age--;
    }
    return age;
}

export default function isValidDob(value, minYear = 1900, minAge = 0) {
    if (!isValidDate(value)) return false;

    const today = new Date();
    const [day, month, year] = value.split('/');
    const dob = new Date(`${month}/${day}/${year}`);

    return year >= minYear && dob < today && getAge(dob) >= minAge;
}
